import styled from 'styled-components'
import { ErrorMessage } from 'formik'

export const StyledErrorMessage = styled(ErrorMessage)`
  padding: 6px 10px;
  font-size: .9rem;
  font-weight: 500;
  color: #f00;
  background-color: #000000;
  border-radius: 5px;
`